<template>
  <RouterView />
  <CookieConsent />
</template>

<script setup lang="ts">
import CookieConsent from '@/components/CookieConsent.vue'
</script>
